<template>
<div v-if="isShow">
    <header>メッセージ非表示リスト<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap">
        <div class="list" v-for="(item, index) in muteList" :key="index">
            <div class="clearfix">
                <div class="list-img"><img :src="item.avatar_url"></div>
                <div class="list-inf">
                    <table>
                        <tr>
                            <td colspan="2">
                                <p><span class="red b">{{ parseInt(item.is_new) === CONSTANTS.IS_NEW ? 'NEW' : '' }}&nbsp;</span> 1日前 <span class="list-name">{{ item.display_name }} {{item.age}}歳 {{ getFieldProfile('living_area', item.living_area) }}</span></p>
                            </td>
                        </tr>
                        <tr v-if="parseInt(item.sex) === CONSTANTS.FEMALE">
                            <td>
                                <p>
                                    <span class="pink" v-if="parseInt(item.enabled_call) === CONSTANTS.ENABLED_CALL">
                                        <i class="fas fa-phone"></i> 通話OK&nbsp;
                                    </span>
                                    <span class="pink2" v-if="parseInt(item.waiting_for_meet) === CONSTANTS.IS_WAITING_FOR_MEET">
                                        <i class="fas fa-calendar-check"></i>本日OK
                                    </span>
                                </p>
                                <p>
                                    <pre>{{ item.mood_status_tmp }}</pre>
                                </p>
                            </td>
                            <td>
                                <div class="iine-btn2"><a @click="unMute(item)">ブロックを解除</a></div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <infinite-loading @infinite="loadMsgHideList" spinner="spiral" :identifier="infiniteId">
        <template v-slot:no-more></template>
        <template v-slot:no-results>
            <div id="wrap">
                <div id="middle">
                    メッセージ非表示リストはありません。
                </div>
            </div>
        </template>
    </infinite-loading>
</div>
</template>

<script>
import CONSTANTS from "@/constants"
import {
    mapGetters
} from "vuex"
export default {
    props: {
        isShow: Boolean,
    },
    emits: ['close'],
    data: () => ({
        muteList: [],
        isGet: true,
        CONSTANTS: CONSTANTS,
        infiniteId: +new Date()
    }),
    mounted() {
        // if (this.isShow) {
        //     this.loadMsgHideList()
        // }
    },
    computed: {
        ...mapGetters(["metadata", 'defaultToken']),
    },
    methods: {
        loadMsgHideList($state = null) {
            if (this.isGet) {
                this.$store.dispatch('profile/getMuteMessages', {
                    token: this.defaultToken
                }).then(data => {
                    if (data.result && data.result[0]) {
                        this.muteList = data.result
                        if ($state) {
                            $state.loaded()
                        }
                        this.isGet = false
                    } else {
                        if ($state) {
                            $state.complete()
                        }
                        this.isGet = false
                    }
                    
                }).catch(err => {
                    if ($state) {
                        $state.complete()
                    }
                    console.log(err)
                })
            } else {
                $state.complete()
            }
        },
        getFieldProfile(field, id) {
            if (!this.metadata.user_profile_list) return null
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        unMute(item, index) {
            let formData = new FormData()
            formData.append('token', this.defaultToken)
            formData.append('user_mute_id', item.id)
            formData.append('type', CONSTANTS.UN_HIDDEN_MESSAGE)
            this.$store.dispatch('profile/muteMessage', formData).then(data => {
                this.isGet = true
                this.muteList = []
                this.infiniteId ++
            }).catch(err => {
                console.log(err)
            })
        }
    }
}
</script>
